import { StyleInputType } from '../../styles/inputType';

export const rangeSliderQuickStylesDefinitions = {
  rangeResultColor: StyleInputType.COLOR,
  rangeThumbColor: StyleInputType.COLOR,
  rangeTrackColor: StyleInputType.COLOR,
  rangeActiveTrackColor: StyleInputType.COLOR,
} satisfies Record<string, StyleInputType>;
